














import { Component, Prop, Vue } from 'vue-property-decorator'

import AppCarouselScroll from '@/components/AppCarouselScroll.vue'

@Component({
  components: {
    AppCarouselScroll
  }
})
export default class extends Vue {
  @Prop(Array) readonly recommendedTags!: string[]
  @Prop(String) readonly tag!: string
  @Prop(Boolean) readonly centered!: boolean

  get tags () {
    return ['전체', ...this.recommendedTags]
  }
}
